import { buildMeetingPath } from '../../utils/url';
import { resolveMeetOrigin } from './meetOrigin';

/**
 * Full-page navigation of the CURRENT tab to NG Meet's standalone meeting URL.
 *
 * This is the hosted-mode (MF) "open in this window" fallback used when the
 * meeting popup is blocked. It must load NG Meet's OWN `index.html` (and its
 * Jitsi `external_api.js`) from NG Meet's origin — NOT render the meeting route
 * inside the TeamHub host shell via the in-app (memory) router, which lacks the
 * standalone HTML/Jitsi bootstrap and would show a broken meeting.
 *
 * Standalone mode keeps using React Router navigation (see callers); only the
 * hosted fallback needs this hard navigation.
 */
export const openMeetingInCurrentTab = (meetingId: string, password?: string | null): void => {
  // `buildMeetingPath` yields `/room` or `/room#passcode`.
  const [pathname, hash] = buildMeetingPath(meetingId, password).split('#');
  const url = new URL(pathname, resolveMeetOrigin());
  window.location.assign(`${url.toString()}${hash ? `#${hash}` : ''}`);
};
